import type { QUICK_TEMPLATES } from "@/constants/campaignBuilder";

type Template = (typeof QUICK_TEMPLATES)[number];

interface QuickTemplateCardProps {
  template: Template;
  index: number;
  selected: boolean;
  setSelectedTemplateIdx: (idx: number) => void;
  onChange: (v: { subject: string; messageHtml: string }) => void;
}

export function QuickTemplateCard({
  template,
  index,
  selected,
  setSelectedTemplateIdx,
  onChange,
}: QuickTemplateCardProps) {
  return (
    <button
      type="button"
      onClick={() => {
        setSelectedTemplateIdx(index);
        onChange({ subject: template.subject, messageHtml: template.messageHtml });
      }}
      className="w-full text-left transition-colors"
      style={{
        display: "flex",
        alignItems: "flex-start",
        gap: 12,
        padding: 12,
        border: selected
          ? "1px solid var(--color-dark-dust)"
          : "1px solid var(--color-card-border)",
        borderRadius: 8,
        marginBottom: 8,
        cursor: "pointer",
        background: selected ? "var(--color-clear-dust)" : "white",
        boxShadow: selected ? "inset 0 0 0 1px var(--color-dark-dust)" : "none",
      }}
    >
      <div
        style={{
          width: 32,
          height: 32,
          borderRadius: 6,
          background: selected ? "var(--color-dark-dust)" : "var(--color-wax)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        <template.Icon sx={{ fontSize: 16, color: selected ? "white" : "var(--color-graphite)" }} />
      </div>
      <div style={{ flex: 1 }}>
        <div
          className="font-lato font-bold"
          style={{
            fontSize: 13,
            color: selected ? "var(--color-dark-dust)" : "var(--color-rodeo-black)",
            marginBottom: 1,
          }}
        >
          {template.name}
        </div>
        <div className="font-lato" style={{ fontSize: 12, color: "var(--color-graphite)" }}>
          {template.desc}
        </div>
      </div>
    </button>
  );
}
